import { If } from '../../../Atoms/Conditionals';
import { DownTick, UpTick } from '../../../Atoms/Slider/tickerComponent';
import { SIGN } from '../utils';

interface CHANGE_PROPS {
  change: number;
  sign: string;
  showInBrackets?: boolean;
  isSmall?: boolean;
}

export const Change = ({
  change,
  sign,
  showInBrackets = false,
  isSmall = false,
}: CHANGE_PROPS): JSX.Element => {
  return (
    <div>
      <If condition={sign === SIGN.POSITIVE}>
        <div className="text-green-400 font-semibold flex items-center gap-1 sm:hidden">
          {showInBrackets && '('}
          <UpTick
            colorString="#349C67"
            width={isSmall ? 7 : 13}
            height={isSmall ? 4 : 7}
          />{' '}
          ₹{change}
          {showInBrackets && ')'}
        </div>
      </If>

      <If condition={sign === SIGN.NEGATIVE}>
        <div className="text-red-400 font-semibold flex items-center gap-1 sm:hidden">
          {showInBrackets && '('}
          <DownTick
            colorString="#FA324C"
            width={isSmall ? 7 : 13}
            height={isSmall ? 4 : 7}
          />{' '}
          ₹{Math.abs(change)}
          {showInBrackets && ')'}
        </div>
      </If>

      <If condition={sign === SIGN.ZERO}>
        <div className="text-font-200 font-semibold flex items-center gap-1 sm:hidden">
          {showInBrackets && '('} ₹{Math.abs(change)} {showInBrackets && ')'}
        </div>
      </If>
    </div>
  );
};
